import BaseSkeleton from 'components/Generic/BaseSkeleton';
import { useI18n } from 'next-localization';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';

type Document = {
  contentType: string;
  documentCategory: string;
  documentId: string;
  documentUri: string;
  editionId: string;
  encoding: string;
  fileName: string;
  id: string;
  lastModified: string;
  title: string;
  keywords: Array<string>;
};

type Props = {
  showSkeleton: boolean;
  paginationData: {
    skip: number;
    take: number;
  };
  documents: Array<Document>;
  localizeDate: (date) => string;
};

const LiteratureHubTable = ({ showSkeleton, paginationData, localizeDate, documents }: Props) => {
  const { t } = useI18n();

  const createLink = (document: Document) => {
    return {
      value: {
        href: '/library/' + document.documentId,
        target: '_blank',
      },
    };
  };
  const checkForValue = (text: string) => {
    return text || t('notAvailableShortMessage');
  };
  return showSkeleton ? (
    <table className="not-striped minimal w-100" aria-label="Literature hub skeleton table">
      <thead>
        <tr className="my-4">
          <th
            scope="col"
            className="section-header-small skeleton-row"
            style={{ borderBottom: '0px solid' }}
          >
            <BaseSkeleton className="w-100" height="56px" />
          </th>
        </tr>
      </thead>
      <tbody>
        {[...Array(paginationData?.take)].map((td) => (
          <tr key={td} className="w-100">
            <td className="w-100 skeleton-row px-0 py-3">
              <BaseSkeleton className="w-100 d-none d-md-block" height="48px" />
              <BaseSkeleton className="w-100 d-block d-md-none" height="56px" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <table className="w-100" aria-label="Literature hub table">
      <thead>
        <tr className="text-nowrap">
          <th scope="col">{t('literatureHubNameFilterLabel')}</th>
          <th scope="col">{t('literatureHubDocumentCodeFilterLabel')}</th>
          <th scope="col">{t('literatureHubDocumentTypeFilterLabel')}</th>
          <th scope="col">{t('literatureHubPublishedDateFilterLabel')}</th>
        </tr>
      </thead>
      <tbody>
        {documents?.map((document) => (
          <tr key={document.id}>
            <td>
              <ScLink
                field={createLink(document)}
                showExternalIcon={false}
                className="h6 hover-underline d-inline-block align-bottom"
              >
                <div className="line-clamp-4">{document.title}</div>
              </ScLink>
            </td>
            <td>{checkForValue(document.editionId)}</td>
            <td>{checkForValue(document.documentCategory)}</td>
            <td>{checkForValue(localizeDate(document.lastModified))}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LiteratureHubTable;
